/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useFormContext } from '@jalik/react-form'
import InterventionInput, { InterventionInputProps } from '../inputs/InterventionInput'
import { FormTextFieldProps } from '../../../../client/js/components/form/fields/FormField'
import { parseNumber } from '@jalik/form-parser'

function InterventionField (props: FormTextFieldProps & Partial<InterventionInputProps>) {
  const { name = 'interventionId', ...others } = props

  const { errors, getFieldProps, handleSetValue } = useFormContext()
  const fieldProps = getFieldProps(name, others)

  return (
    <InterventionInput
      error={errors[name]?.message}
      {...fieldProps}
      name={name}
      onChange={handleSetValue(name, { parse: parseNumber })}
    />
  )
}

export default InterventionField
